export default __webpack_public_path__ + "static/amazon.url-4524a0a01b18c9154e05e662389b09bb.svg";